module.exports = __webpack_public_path__ + "dizzy.444e9859.png";